module.exports = __webpack_public_path__ + "static/media/personal_folder_p1_2.c632c4d9.png";